<template>
  <label
    for="upload-image"
    :class="'upload-image ' + (imageNotValid ? ' div-error ' : '')"
  >
    <div v-if="file && !avatarImgLoaded && !previevImage" class="file-inner">
      <div class="file-content">
        <div class="file-title">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 4H7.5C7.10218 4 6.72064 4.16857 6.43934 4.46863C6.15804 4.76869 6 5.17565 6 5.6V18.4C6 18.8243 6.15804 19.2313 6.43934 19.5314C6.72064 19.8314 7.10218 20 7.5 20H16.5C16.8978 20 17.2794 19.8314 17.5607 19.5314C17.842 19.2313 18 18.8243 18 18.4V8.5L13.5 4Z"
              fill="#929BAA"
            />
            <path
              d="M13 4.5V8.5C13 8.77614 13.2239 9 13.5 9H17.5"
              fill="white"
            />
          </svg>
          <span>{{ file.name }}</span>
        </div>
        <div class="file-size">{{ Math.round(file.size / 1024) }}kb</div>
        <div class="file-loader">
          <div
            class="file-loader__bar"
            :style="
              'width: ' +
              (otherUploadPercentage ? otherUploadPercentage : '0') +
              '%;'
            "
          />
        </div>
      </div>
      <div v-if="otherUploadPercentage == 100" class="file-status">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="8" fill="#29CC44" />
          <path
            d="M16 9.33203L10.8571 14.6654L8 11.7563"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div v-show="loaderImg" class="upload-image__img-container loader-image">
      <SimplePreloader />
    </div>
    <div
      v-show="imagePreview && !previevImage"
      class="upload-image__img-container"
    >
      <div class="hover_upload-new">
        <icon name="edit_class_column" />
      </div>
      <input
        type="file"
        accept=".png, .jpg, .jpeg, .gif"
        max-size="2000"
        class="upload-image__input"
        @change="$emit('change', $event)"
      />

      <img
        class="upload-image__upload-img"
        :src="imagePreview ? '/storage/' + imagePreview : ''"
      />
    </div>
    <div class="upload-image__img-container">
      <img :src="previevImage" />
    </div>

    <div
      v-show="!imagePreview && !previevImage"
      @dragover.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      class="upload-image__zone"
      :class="{ dragover: dragover }"
    >
      <input
        id="upload-image"
        type="file"
        accept=".png, .jpg, .jpeg, .gif"
        max-size="2000"
        class="upload-image__input"
        @change="$emit('change', $event)"
      />

      <div class="upload-image__zone-icon">
        <icon name="image-svg" />
      </div>
      <div class="upload-image__zone-title">{{ blockTitle }}</div>
      <div class="upload-image__zone-text" v-html="blockText"></div>
    </div>
    <div v-show="imageNotValid" class="form__field-error">
      {{ imageError }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'UploadImage',
  props: {
    imageNotValid: {
      default: false
    },
    imagePreview: {
      default: false
    },
    imageError: {
      default: false
    },
    blockTitle: {
      default: false
    },
    blockText: {
      default: false
    },
    loaderImg: {
      default: false
    },
    avatarImgLoaded: {
      default: false
    },
    file: {
      default: ''
    },
    otherUploadPercentage: {
      default: 0
    },
    previevImage: {
      default: null
    }
  },
  data() {
    return {
      dragover: false
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.file-inner {
  position: absolute;
  z-index: 3;
  .file-content {
    width: 100%;
    .file-title {
      width: 80%;
      font-size: 9px;
    }
  }
}
.upload-image__img-container:hover {
  .hover_upload-new {
    background-color: #e5f2ff;
    stroke: #409fff;
    opacity: 0.5;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.hover_upload-new {
  padding: 10px;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}
</style>
